import { useTranslation } from "react-i18next";
import { careBalanceStatusMap } from "./constants/careBalanceStatusMap.js";
import Tooltip from "./Tooltip.jsx";

const infoCircleAlert = "/img/care-balance/info-circle-alert.svg";

function CareBalanceStatus({ activeStatusId }) {
  const { t } = useTranslation("careBalance");

  const status = careBalanceStatusMap.get(activeStatusId);

  if (!activeStatusId) {
    return null;
  }

  const statusColor =
    status === "Active"
      ? "#288D68"
      : ["Pending", "Delayed"].includes(status)
      ? "unset"
      : "#CB193B";

  return (
    <>
      <span
        style={{
          color: statusColor,
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {status}

        {status !== "Active" && (
          <Tooltip
            title={t("inactiveBalanceModalTitle")}
            description={t("inactiveBalanceModalDescription")}
          >
            <img
              src={infoCircleAlert}
              style={{
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
            />
          </Tooltip>
        )}
      </span>
    </>
  );
}

export default CareBalanceStatus;
